import React from "react";

import styled from "@emotion/styled";

const Headings = styled.h1`
  color: #000000;
  font-family: poppins;
  font-weight: 900;
  font-size: ${(props) => props.fs};
  margin-bottom: ${(props) => props.mb};
  margin-top: ${(props) => props.mt};
  margin-left: ${(props) => props.ml};
  text-align: ${(props) => props.ta};
  @media (max-width: 1199px) {
    font-size: 50px;
  }
  @media (max-width: 599px) {
    margin-bottom: ${(props) => props.mb599};
    font-size: 40px;
    margin-left: 10px;
  }
`;
const Heading = (props) => {
  return (
    <div>
      <Headings
        // data-aos="fade-zoom-in"
        // data-aos-easing="ease-in"
        // // data-aos-delay="500"
        // // data-aos-offset="0"
        // data-aos-duration="1500"
        // className="mr-3"
        fs={props.fs ? props.fs : "70px"}
        mb={props.mb ? props.mb : "1.5rem"}
        mb599={props.mb599 ? props.mb599 : "0px"}
        mt={props.mt ? props.mt : "0rem"}
        ml={props.ml ? props.ml : "0rem"}
        ta={props.ta ? props.ta : ""}
      >
        {props.children}
      </Headings>
    </div>
  );
};

export default Heading;
